<template>
 <div class="card event-card" :class="{ 'event-clickable': link }" @click="redirect(link)">
  <div v-if="isLoading" class="skeleton-loader-full-card"></div>
  <div v-show="!isLoading" class="card-content">
    <div class="img-card-event">
      <img :src="imgSrc" @load="onImageLoad" />
    </div>
    <div class="text-card-event">
      <div>
        <div class="date-card-event">{{ date }}</div>
        <div class="title-card-event">{{ title }}</div>
      </div>
      <div class="description-card-event" v-html="description"></div>
      <a v-if="link" :href="link" target="_blank" class="event-link" @click.stop>
        Saiba mais <i class="fa fa-external-link"></i>
      </a>
    </div>
  </div>
 </div>
</template>

<script>
export default {
 name: "CardEvent",
 props: {
  tag: {
   default: "SEM CATEGORIA",
  },
  date: {
   default: "(sem data definida)",
  },
  title: {
   default: "Titulo do evento",
  },
  imgSrc: {
   default: "seminario.jpg",
  },
  link: {
    default: ''
  },
  description: {
    default: "--",
  },
 },
 data() {
    return {
        isLoading: true
    }
 },
 methods: {
    redirect(value) {
        if (this.link) {
            window.open(value, '_blank')
        }
    },
    onImageLoad() {
        this.isLoading = false
    }
 },
 watch: {
    imgSrc() {
        this.isLoading = true;
    }
 }
};
</script>

<style scoped>
.event-card {
 display: flex;
 align-items: center;
 text-align: left;
 position: relative;
 overflow: hidden;
 transition: box-shadow 0.25s ease;
}

.event-clickable {
  cursor: pointer;
}

.event-clickable:hover {
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.12);
}

.skeleton-loader-full-card {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  z-index: 2;
  border-radius: 10px;
}

@keyframes loading {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}

.card-content {
  display: flex;
  align-items: center;
  gap: 40px;
  text-align: left;
  width: 100%;
}

.img-card-event {
 overflow: hidden;
 width: 200px;
 min-width: 200px;
 height: 200px;
 margin-left: 40px;
 border-radius: 8px;
}

.img-card-event img {
 width: 100%;
 height: 100%;
 object-fit: cover;
 display: block;
}

.text-card-event {
 display: flex;
 flex-direction: column;
 gap: 10px;
 padding-right: 30px;
}

.title-card-event {
 color: #2c3e50;
 font-size: 28px;
 font-weight: 700;
 line-height: 1.2;
}

.date-card-event {
 font-size: 13px;
 color: #999;
 text-transform: uppercase;
 letter-spacing: 1px;
 margin-bottom: 4px;
}

.description-card-event {
 font-size: 15px;
 color: #666;
 line-height: 1.5;
}

.event-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #3366cc;
  text-decoration: none;
  transition: color 0.2s ease;
}

.event-link:hover {
  color: #1a4a99;
}

.event-link .fa {
  font-size: 12px;
}

@media screen and (max-width: 981px) {
 .event-card {
  flex-direction: column;
  align-items: center;
  text-align: center;
 }
 .card-content {
  flex-direction: column;
  align-items: center;
  gap: 20px;
 }
 .text-card-event {
  align-items: center;
  padding: 0 20px;
 }
 .img-card-event {
  margin: 0;
 }
}
</style>
